import React, { Suspense, lazy } from 'react';

import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';

const ClientDetailFormEdit = lazy(
  () => import('@components/Client/ClientDetailFormEdit')
);

/** 마스터 계정 > 회사 관리 > 상세 > 수정하기 */
const ClientEdit = () => {
  return (
    <>
      <ApiErrorBoundary>
        <Suspense>
          <ClientDetailFormEdit />
        </Suspense>
      </ApiErrorBoundary>
    </>
  );
};

export default ClientEdit;
